import React, { useState } from 'react';
import { useAuthProvider } from '../../providers/AuthProvider';
import AIChatbot from './AIChatbot';
import AdminChatbot from './AdminChatbot';
import aiChatIcon from '../img/ai_chat_icon.png';

const ChatbotLauncher = ({ theme = 'light' }) => {
    const [adminChatOpen, setAdminChatOpen] = useState(false);
    const { profile, loggedIn, isLoading, features, permissions, isDev } = useAuthProvider();

    // Don't show chatbot if user is not logged in or still loading auth state
    if (!loggedIn || isLoading) {
        return null;
    }

    // Don't show if perm_use_ai is false
    const canUseAi = isDev || (permissions && permissions.perm_use_ai);
    if (!canUseAi) {
        return null;
    }

    // Don't show if AI feature is disabled for this company
    if (features?.ai === false) {
        return null;
    }

    const isAdmin = profile?.group === 'ADMIN' || profile?.role === 'admin';

    // Only show AI assistant for admin users - customers don't get AI access for security reasons
    if (!isAdmin) {
        return null;
    }

    return (
        <div className="chatbot-launcher">
            {/* Admin Assistant - only available to admin users */}
            <button
                className="chatbot-launch-btn admin-btn"
                onClick={() => setAdminChatOpen(true)}
                title="Admin Assistant"
            >
                <img src={aiChatIcon} alt="AI" className="chatbot-icon admin-icon" />
            </button>

            {/* Admin Chatbot Modal */}
            {adminChatOpen && (
                <AdminChatbot
                    onClose={() => setAdminChatOpen(false)}
                />
            )}

            <style>{`
                .chatbot-launcher {
                    position: fixed;
                    bottom: 20px;
                    right: 20px;
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    z-index: 1000;
                }

                .chatbot-launch-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 12px;
                    border: none;
                    border-radius: 50%;
                    cursor: pointer;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
                    transition: all 0.3s ease;
                    width: 56px;
                    height: 56px;
                }

                .customer-btn {
                    background: linear-gradient(135deg, #007bff, #0056b3);
                    color: white;
                }

                .customer-btn:hover {
                    background: linear-gradient(135deg, #0056b3, #004085);
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);
                }

                .admin-btn {
                    background: linear-gradient(135deg, #dc3545, #c82333);
                    color: white;
                }

                .admin-btn:hover {
                    background: linear-gradient(135deg, #c82333, #a71e2a);
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(220, 53, 69, 0.4);
                }

                .chatbot-icon {
                    width: 24px;
                    height: 24px;
                    border-radius: 4px;
                }

                .admin-icon {
                    filter: hue-rotate(0deg) saturate(1.2) brightness(1.1);
                }

                @media (max-width: 768px) {
                    .chatbot-launcher {
                        bottom: 10px;
                        right: 10px;
                    }

                    .chatbot-launch-btn {
                        width: 48px;
                        height: 48px;
                        padding: 10px;
                    }

                    .chatbot-icon {
                        width: 24px;
                        height: 24px;
                    }
                }
            `}</style>
        </div>
    );
};

export default ChatbotLauncher;